import CrudCustom from '../../../libs/custom/CrudCustom';

let TransaksiBebanEntertainmentService = new CrudCustom('/transaksi-beban-entertainments');
export default TransaksiBebanEntertainmentService;
